<template>
  <div id="mapView">
    <div id="mapBox">
      <img id="mapArt" src="@/assets/img/map/map-full.svg">
      <img id="cloud1" src="@/assets/img/map/mist1.png">
      <img id="cloud2" src="@/assets/img/map/mist2.png">
      <img id="cloud3" src="@/assets/img/map/mist1.png">
      <img id="cloud4" src="@/assets/img/map/mist2.png">
      <img id="boat1" class="riverObject" src="@/assets/img/map/boat.png">
      <img id="boat2" class="riverObject" src="@/assets/img/map/boat.png">
      <svg id="forestSvg" viewBox="0 0 3000 3000"></svg>
    </div>
    <div id="UIBox">
      <b-row>
        <div class="box mb-2 mr-2">
          <h4 class="text-center">Our Forest of Purpose</h4>
          <p class="text-center">To begin exploring, click on any tree on this map, or select a team from this dropdown list.</p>
          <div class="form-group">
            <b-form-select v-model="treeIndex" :options="treeGroupsUI" size="sm" @change="selectGroupUI"></b-form-select>
          </div>
        </div>
        <div class="box" v-if="this.selectedTree != null || buttonVisible">
          <div class="text-center">
              <h5 class="text-info">{{ selectedTree.group }}</h5>
              <p v-html="namesSubmittedUI"></p>
          </div>
          <div class="text-center" v-if="buttonVisible">
            <b-button variant="info" @touchstart="touchUIButton">Go to Tree!</b-button>
          </div>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3"
import { mapState, mapMutations } from 'vuex'

export default {
  name: "MapView",
  data: () => ({
      treeIndex: -1,
      buttonVisible: false,
      selectedTree: null
  }),
  computed: {
    ...mapState([
      "forestData",
      "submissionsData",
    ]),
    treeGroupsUI: function() {
      let base = [{value: -1, text: "Select a group"}];

      return base.concat(this.forestData.map((d,i) => {
          return {value: i, text: d.group}
      }))
    },
    namesSubmittedUI: function() {
      let textString = "";
      let nameArray = this.selectedTree.submittedNames;

      if (this.selectedTree.submissions > 2 ) {
        this.shuffleArray(nameArray);
        textString = "<span class='text-info'><b>" + this.selectedTree.submissions + " stories</b></span> submitted by people like "
          + nameArray[0] + ", "
          + nameArray[1] + ", "
          + " and " + nameArray[2];
      } else if (this.selectedTree.submissions == 2 ) {
        textString = "<span class='text-info'><b>" + this.selectedTree.submissions + " stories</b></span> by "
          + nameArray[0]
          + " and " + nameArray[1];
      } else if (this.selectedTree.submissions == 1 ) {
        textString = "<span class='text-info'><b>" + this.selectedTree.submissions + " story</b></span> by " + nameArray[0];
      } else {
        textString = "No stories. Be the first!";
      }

      return textString;
    }
  },
  methods: {
    ...mapMutations([
      "updateGroup",
      "updateWishes",
    ]),
    shuffleArray: function(array) {
      for (var i = array.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var temp = array[i];
          array[i] = array[j];
          array[j] = temp;
      }
    },    
    drawForest: function() {
      let forest = d3.select("svg#forestSvg")
          .selectAll("g")
          .data(this.forestData)
          .enter()
          .append("g");

      forest
          .append("circle")
          .attr("class", "tree")
          .attr("cx", d =>  {
            return parseInt(d.x) + 100;
          })
          .attr("cy", d =>  {
            return parseInt(d.y) + 100;
          })
          .attr("r", 110)
          .attr("fill", "transparent")
          .on("mouseover", (event, d) => {
            d3.select(event.currentTarget)
            .attr("stroke", "yellow")
            .attr("stroke-width", 10);
            this.selectedTree = d;
          }) 
          .on("mouseout", (event) => {
            d3.select(event.currentTarget)
            .attr("stroke", "none");
            this.selectedTree = null;
            this.buttonVisible = false;
          })
          .on("click", (event, d) => {
            //check for touchscreen
            if (event.pointerType != "mouse") {
              event.preventDefault();
              this.buttonVisible = true;
              this.selectedTree = d;
            } else {
              this.goToTree(d);
            }
          })

        forest
          .append("image")
          .attr("xlink:href", d => d.treeIcon)
          .attr("x", d => d.x)
          .attr("y", d => d.y)
          .attr("width", 200)
          .attr("height", 200)
          .attr("pointer-events", "none");
    },
    selectGroupUI: function(index) {
      let d = this.forestData[index];
      this.goToTree(d);
    },
    touchUIButton: function() {
      this.goToTree(this.selectedTree);
    },
    goToTree: function(d) {
      this.updateGroup(d);
      let submissions = this.submissionsData.filter(e => e.group == d.group);

      submissions.sort((a,b) => {
        if (a.name > b.name) {
          return 1;
        } else {
          return -1;
        }
      })

      this.updateWishes(submissions);
      this.$emit("forestToTree", d);
    },
    resizeMap: function() {
      let width = window.innerWidth;
      let height = window.innerHeight;

      if (width < height + 380) { 
        height = height - 200;

        if (width < height) {  //portrait mode
          d3.select("#mapArt")
          .style("height", width + "px");

          d3.select("#UIBox")
          .style("position", "absolute")
          .style("top", width + "px")
          .style("left", (width /2 - 175) + "px")
          .style("width", "380px");

        } else {
          d3.select("#mapArt")
          .style("height", height + "px");

          d3.select("#UIBox")
          .style("position", "absolute")
          .style("top", height + "px")
          .style("left", (width /2 - 370) + "px")
          .style("width", "770px");

          d3.selectAll(".box")
          .style("width", "380px");
        }

        if (width > height) { width = height } //square aspect ratio

        d3.select("#mapBox")
        .style("width",  width + "px")
        .style("height",  height + "px");

        d3.selectAll(".riverObject")
        .style("width", "50px")
        .style("top",  (width * 0.34) + "px");

      } else {
        if (width > height) { width = height }

        d3.select("#mapArt")
        .style("height", height + "px")

        d3.select("#UIBox")
        .style("position", "absolute")
        .style("top", (window.innerHeight / 2 - 200) + "px")
        .style("left", (window.innerWidth / 2 + width / 2 - 200) + "px")
        .style("width", "400px");

        d3.select("#mapBox")
        .style("width",  width + "px")
        .style("height",  height + "px");

        d3.selectAll(".riverObject")
        .style("width", "97px")
        .style("top",  (width * 0.34) + "px");
      }

      d3.select("#cloud1")
        .style("top",  (height * 0.15) + "px");
      d3.select("#cloud2")
        .style("top",  (height * 0.3) + "px");
      d3.select("#cloud3")
      .style("top",  (height * 0.5) + "px");
      d3.select("#cloud4")
      .style("top",  (height * 0.65) + "px");
    }
  },
  mounted: function () {
    this.resizeMap();
  },
  created: function () {
      window.addEventListener("resize", this.resizeMap);
  },
  destroyed() {
      window.removeEventListener("resize", this.resizeMap);
  },    
  watch:  {
    forestData: {
      immediate: true, 
      handler () {
        this.drawForest();
      }
    }
  }
}
</script>

<style scoped>
#mapBox {
  position: absolute;
}

#cloud1, #cloud2, #cloud3, #cloud4 {
  position: absolute;
  left: -500px;
}

#boat1, #boat2 {
  position: absolute;
  left: -97px;
}

#mapArt {
  position: absolute;  
}
#forestSvg {
  position: absolute;
  width: 100%;
  left: 100px;
  top: 0%;
}

.box {
  background: white;
  border-radius: 10px;
  opacity: 90%;
  padding: 15px;
  width: 380px;
  height: 150px;
}

#UIBox p {
  line-height: 1.2em;
}

@media only screen and (max-width: 800px) {
  #forestSvg {
    left: 0px;
  }
}
</style>
